<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="d-flex flex-column w-100 h-100 justify-content-center align-items-center">
    <div class="mw-100 p-5">
      <img
        class="w-100"
        src="@/assets/images/404/Img-404-01@2x.png"
        alt=""
      >
    </div>
    <div class="font-size-md text-center">
      <div v-html="content" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // 錯誤訊息，可傳入HTML字串
    content: {
      type: String,
      default() { return this.$t('error.page-not-found'); },
    },
  },
};
</script>
